// A wrapper for <Route> that redirects to the login

import React from "react";
import { Redirect, Route } from "react-router-dom";
import { PATH } from "../../config";
import { useAuth } from "./ProvideAuth";
// screen if you're not yet authenticated.
function PublicRoute({ children, ...rest }) {
  let auth = useAuth();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.user && auth.user.token ? (
          <Redirect
            to={{
              // pathname: PATH.DASHBOARD.replace(":type", "ceo"),
              pathname: PATH.HOME,
              state: { from: location },
            }}
          />
        ) : (
          <>{children}</>
        )
      }
    />
  );
}
export default PublicRoute;
